import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import OverflowTabs, { ITabItem } from 'app/shared/common-fun/OverflowTabs';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { useDispatch } from 'react-redux';
import { getEntityNewsFeed } from 'app/entities/news-feed/news-feed.reducer';
import { getEntities, getEntityInspirationsAdmin } from 'app/entities/inspiration/inspiration.reducer';
import { useNavigate } from 'react-router-dom';
import { getEntitiesProfile, getEntityAdminTopFive } from 'app/entities/adminprofile/adminprofile.reducer';
import { getEntityannouncement } from './announcement/announcement.reducer';

interface Props {
  tab1Content: React.ReactNode;
  tab2Content: React.ReactNode;
  tab3Content: React.ReactNode;
  tab4Content: React.ReactNode;
  tab5Content: React.ReactNode;
  tab6Content: React.ReactNode;
  tab7Content: React.ReactNode;
  tab8Content: React.ReactNode;
  tab9Content: React.ReactNode;
  tab10Content?: React.ReactNode;
  tab11Content?: React.ReactNode;
  currentActiveTab: React.ReactNode;
}

const tabItems: ITabItem[] = [
  { id: 'admindashboard', label: 'Admin Dashboard', icon: 'content/images/Dashboard-icon.svg' },
  { id: 'users', label: 'Users', icon: 'content/images/Users-icon.svg' },
  { id: 'newsfeed', label: 'Interest / Newsfeed', icon: 'content/images/News-Feed-icon.svg' },
  { id: 'inspirations', label: 'Inspirations', icon: 'content/images/Inspiration-icon.svg' },
  { id: 'topic', label: 'Topics', icon: 'content/images/MyConnections-icon.svg' },
  { id: 'point-details', label: 'Point Details', icon: 'content/images/ChartDonut.svg' },
  { id: 'announcement', label: 'Announcements', icon: 'content/images/megaphone.svg' },
  { id: 'interview', label: 'Interviews', icon: 'content/images/megaphone.svg' },
  { id: 'earn-more-points', label: 'Earn More Points', icon: 'content/images/ChartDonut.svg' },
  { id: 'housing', label: 'Housing', icon: 'content/images/Inspiration-icon.svg' },
  { id: 'governance', label: 'Good Governance', icon: 'content/images/Inspiration-icon.svg' },
];

const AdminTabs: React.FC<Props> = ({
  tab1Content,
  tab2Content,
  tab3Content,
  tab4Content,
  tab5Content,
  tab6Content,
  tab7Content,
  tab8Content,
  tab9Content,
  tab10Content,
  tab11Content,
  currentActiveTab,
}) => {
  const [activeTab, setActiveTab] = useState('admindashboard');
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const account = useAppSelector(state => state.authentication.account);
  const userProfileEntity = useAppSelector(state => state.userProfile.entity[0]);

  const id = account.id;
  const navigate = useNavigate();

  useEffect(() => {
    if (currentActiveTab === 'inspirations') {
      setActiveTab('inspirations');
    }
  }, [currentActiveTab]);

  const toggle = async (tab: string) => {
    setLoading(true);
    if (activeTab !== tab) setActiveTab(tab);

    if (tab === 'admindashboard') {
      await dispatch(getEntityAdminTopFive());
    } else if (tab === 'users') {
      await dispatch(getEntitiesProfile({ page: 0, size: 10 }));
    } else if (tab === 'newsfeed') {
      await dispatch(
        getEntityNewsFeed({
          id: id,
          page: 0,
          size: 20,
          sort: ``,
        })
      );
    } else if (tab === 'announcement') {
      await dispatch(
        getEntityannouncement({
          id: id,
          page: 0,
          size: 20,
          sort: `id,desc`,
        })
      );
    } else if (tab === 'inspirations') {
      await dispatch(
        getEntityInspirationsAdmin({
          page: 0,
          size: 20,
          sort: 'id,desc',
        })
      );
    } else if (tab === 'topic') {
      await dispatch(getEntitiesProfile({ page: 0, size: 10 }));
    }
    navigate(`/admin/${tab}`);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div className="wrapper">
      <OverflowTabs items={tabItems} activeTab={activeTab} onSelect={tab => void toggle(tab)} />
      <TabContent activeTab={activeTab}>
        <TabPane tabId="admindashboard">{activeTab === 'admindashboard' && tab1Content}</TabPane>
        <TabPane tabId="users">{activeTab === 'users' && tab2Content}</TabPane>
        <TabPane tabId="newsfeed">{activeTab === 'newsfeed' && tab3Content}</TabPane>
        <TabPane tabId="inspirations">{activeTab === 'inspirations' && tab4Content}</TabPane>
        <TabPane tabId="topic">{activeTab === 'topic' && tab5Content}</TabPane>
        <TabPane tabId="point-details">{activeTab === 'point-details' && tab6Content}</TabPane>
        <TabPane tabId="announcement">{activeTab === 'announcement' && tab7Content}</TabPane>
        <TabPane tabId="interview">{activeTab === 'interview' && tab8Content}</TabPane>
        <TabPane tabId="earn-more-points">{activeTab === 'earn-more-points' && tab9Content}</TabPane>
        <TabPane tabId="housing">{activeTab === 'housing' && tab10Content}</TabPane>
        <TabPane tabId="governance">{activeTab === 'governance' && tab11Content}</TabPane>
      </TabContent>
    </div>
  );
};

export default AdminTabs;
